import { logEvent } from './logGaEvent'

const logNoResults = ({ isReshopExperience, urlParams = {} }) => {
  const getItemName = () => {
    const searchType = urlParams['usp-cache-key'] ? 'package' : 'flight'

    if (!isReshopExperience) {
      return `${searchType}_path`
    }

    const exchangeType = urlParams.userActionType === 'MODIFY' ? 'now' : 'later'
    return `${searchType}_exchange_${exchangeType}`
  }

  const attributes = {
    type: 'search_results_not_found',
    item_name: getItemName(),
    page_name: 'listings',
    product_name: 'air',
  }

  logEvent('display', attributes)
}

export { logNoResults }
